const { REACT_APP_API_URL_TOKEN_TRADER } = process.env;

async function handleResponse(res) {
  if (!res.ok) {
    const { error } = await res.json();
    throw new Error(error);
  }

  return await res.json();
}

async function fetchInit({ url, accessToken, method }) {
  return await fetch(`${REACT_APP_API_URL_TOKEN_TRADER}${url}`, {
    method,
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });
}

async function request({ url, accessToken, method }) {
  return await fetchInit({ url, accessToken, method }).then((res) => handleResponse(res));
}

async function tradeToken(cognitoIdToken) {
  return await request({
    url: '/token',
    accessToken: cognitoIdToken,
    method: 'POST',
  });
}

async function createAccount(cognitoIdToken) {
  return await request({
    url: '/accounts',
    accessToken: cognitoIdToken,
    method: 'POST',
  });
}

async function isAccountExists(cognitoIdToken) {
  let res = await fetchInit({
    url: '/shared-accounts/me',
    accessToken: cognitoIdToken,
    method: 'GET',
  });
  return res.ok;
}

export default {
  createAccount,
  isAccountExists,
  tradeToken,
};
